// React error boundaries — v2.7 Error Quality Lock.
// Users and the founder NEVER see stack traces or raw exception text.
import React from 'react';

const COPY = {
  consumer: {
    bg: '#F7F5F1', fg: '#0D0D0D', sub: '#8E8A84', btn: '#0D0D0D', btnFg: '#F7F5F1',
    title: 'Something went wrong on this screen.',
    body: 'Your data is safe and nothing was changed. Try refreshing — if this keeps happening, we already logged it for review.',
  },
  founder: {
    bg: '#0B0D12', fg: '#E9EBF1', sub: '#8C93A6', btn: '#C7A96B', btnFg: '#0B0D12',
    title: 'This console page hit an error.',
    body: 'The app kept everything unchanged. Try again, or open Issues if this keeps happening. No founder action is lost.',
  },
};

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // Log for developers only — never rendered.
    console.error('[ErrorBoundary]', error?.message);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    const c = COPY[this.props.variant || 'consumer'];
    return (
      <div style={{ minHeight: '100dvh', background: c.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px' }}
        data-testid={`error-boundary-${this.props.variant || 'consumer'}`}>
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: 24, color: c.fg, marginBottom: 12 }}>{c.title}</h1>
          <p style={{ fontFamily: 'Arial, sans-serif', fontSize: 14, color: c.sub, lineHeight: 1.6, marginBottom: 24 }}>{c.body}</p>
          <button onClick={() => { this.setState({ hasError: false }); window.location.reload(); }}
            data-testid="error-boundary-retry"
            style={{ minHeight: 44, background: c.btn, color: c.btnFg, border: 'none', borderRadius: 999, padding: '12px 28px', fontFamily: 'Arial, sans-serif', fontSize: 13, fontWeight: 600, cursor: 'pointer' }}>
            Try again
          </button>
        </div>
      </div>
    );
  }
}
